var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cs-segment',{staticClass:"cs-segment-print"},[_c('cs-container',[_c('cs-row',[_c('cs-col',{staticClass:"copyright text"},[_c('p',[_vm._v(" Copyright "+_vm._s(_vm._f("replace")(_vm.$store.state.site.meta.copyright,'{year}', _vm.year))+" | "+_vm._s(_vm.$store.state.site.contact.email.title)+" ")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }